goog.provide('el8.appshared.drugIntxns');

goog.require('el8.ptdata.medOrderThreads');
goog.require('el8.appshared.dialog.drugIntxnDetail');
goog.require('el8.appshared.dialog.drugIntxnUnknownDetail');

goog.require('el8.util.base');
goog.require('el8.template.appshared.drugIntxns');
goog.require('el8.model.AjaxQueue');

el8.appshared.drugIntxns = (function() {

    var latestMedicationId = null;
    var latestMedicationName = null;
    var latestDrugDrugIntxn = null;
    var latestDrugAllergyIntxn = null;

    $(document).on('click', '.drug-drug-interaction-detail', function(e) {
        if (!latestDrugDrugIntxn) { return; }
        var section = $(this).attr('_section');
        el8.appshared.dialog.drugIntxnDetail.show({
            type: 'drugDrug',
            selected_medication_name: latestDrugDrugIntxn['selected_medication_name'],
            severity_level: section.capitalize(),
            interactions: latestDrugDrugIntxn[section+'_severity_interactions']
        });
    });

    $(document).on('click', '.drug-allergy-interaction-detail', function(e) {
        if (!latestDrugAllergyIntxn) { return; }
        el8.appshared.dialog.drugIntxnDetail.show({
            type: 'drugAllergy',
            selected_medication_name: latestDrugAllergyIntxn['selected_medication_name'],
            interactions: latestDrugAllergyIntxn['interactions']
        });
    });

    $(document).on('click', '.drug-drug-unknown-detail', function(e) {
        if (!latestDrugDrugIntxn) { return; }
        el8.appshared.dialog.drugIntxnUnknownDetail.show({
            type: 'drugDrug',
            selected_medication_name: latestDrugDrugIntxn['selected_medication_name'],
            unknown_medications: latestDrugDrugIntxn['unknown_medications']
        });
    });

    $(document).on('click', '.drug-allergy-unknown-detail', function(e) {
        if (!latestDrugAllergyIntxn) { return; }
        el8.appshared.dialog.drugIntxnUnknownDetail.show({
            type: 'drugAllergy',
            selected_medication_name: latestDrugAllergyIntxn['selected_medication_name'],
            unknown_medications: latestDrugAllergyIntxn['unknown_medications'],
            unknown_allergies: latestDrugAllergyIntxn['unknown_allergies']
        });
    });

    return {

        reset: function() {
            latestMedicationId = null;
            latestMedicationName = null;
            latestDrugDrugIntxn = null;
            latestDrugAllergyIntxn = null;
        },
        getMajorIntxns: function() {
            var rv = {};
            if (latestDrugDrugIntxn && latestDrugDrugIntxn['major_severity_interactions'].length) {
                rv.drugDrug = latestDrugDrugIntxn['major_severity_interactions'];
            }
            if (latestDrugAllergyIntxn && latestDrugAllergyIntxn['interactions'].length) {
                rv.drugAllergy = latestDrugAllergyIntxn['interactions'];
            }
            return el8.util.isEmptyObj(rv) ? null : rv;
        },
        getMajorIntxnsMsgs: function() {
            var intxns = this.getMajorIntxns();
            if (intxns) {
                var rv = {};
                if (intxns['drugDrug']) {
                    rv['drugDrug'] = intxns['drugDrug'].map(function(a) { return a['message']; }).join("\n");
                }
                if (intxns['drugAllergy']) {
                    rv['drugAllergy'] = intxns['drugAllergy'].map(function(a) { return a['message']; }).join("\n");
                }
                return rv;
            }
            return null;
        },
        lookup: function(medicationId, medicationName, elt, successCb) {

            latestMedicationId = medicationId;
            latestMedicationName = medicationName;
            latestDrugDrugIntxn = null;
            latestDrugAllergyIntxn = null;

            if (elt) {
                elt.html(el8.template.appshared.drugIntxns.alertsShell());
            }

            var dict = {};
            dict['medication_id'] = medicationId;
            if (!medicationId) { dict['medication_name'] = medicationName; }

            dict['include_major_severity'] = true;
            dict['include_moderate_severity'] = true;
            dict['include_minor_severity'] = true;

            switch(el8.data.currUser.getCdsDrugDrugAlertLevel()) {
                // For the major-only levels:
                case 1:
                    dict['include_moderate_severity'] = false;
                    dict['include_minor_severity'] = false;
                    break;
                // For the major and moderate levels:
                case 2:
                    dict['include_minor_severity'] = false;
                    break;
                // For show-all-alerts levels:
                case 3:
                    break;
            }

            var drugDrugDict = $.extend({}, dict);
            var drugAllergyDict = $.extend({}, dict);
            var that = this;

            // First do drug-drug
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('drugDrugIntxn'),
                data: {'data': JSON.stringify(drugDrugDict)},
                success: function(data) {
                    $.extend(data, {
                        selected_medication_id: medicationId,
                        selected_medication_name: medicationName
                    });
                    latestDrugDrugIntxn = data;
                    if (elt) {
                        $('.drug-drug-alert', elt).html(el8.template.appshared.drugIntxns.drugDrugResultSummary(data));
                    }
                    if (successCb) { successCb(data); }
                },
                error_override: function(data) {
                    if (elt) {
                        $('.drug-drug-alert', elt).html(el8.template.appshared.drugIntxns.drugDrugError());
                    }
                    latestMedicationId = null;
                    latestMedicationName = null;
                    latestDrugDrugIntxn = null;
                }
            });

            // Then do drug-allergy (if user settings agree)
            if (el8.data.currUser.isShowCdsDrugAllergyAlert()) {
                $.el8_ajax({
                    type: 'POST',
                    url: el8.service.urls.get('drugAllergyIntxn'),
                    data: {'data': JSON.stringify(drugAllergyDict)},
                    success: function(data) {
                        $.extend(data, {
                            selected_medication_id: medicationId,
                            selected_medication_name: medicationName
                        });
                        latestDrugAllergyIntxn = data;
                        if (elt) {
                            $('.drug-allergy-alert', elt).html(el8.template.appshared.drugIntxns.drugAllergyResultSummary(data));
                        }
                        if (successCb) { successCb(data); }
                    },
                    error_override: function(data) {
                        if (elt) {
                            $('.drug-allergy-alert', elt).html(el8.template.appshared.drugIntxns.drugAllergyError());
                        }
                        latestMedicationId = null;
                        latestMedicationName = null;
                        latestDrugAllergyIntxn = null;
                    }
                });
            }

        }
    };

})();
